import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy">
            <h3 className="fs_xlg tc-p txt-a-c mb_md">[ 개인정보 처리 방침 ]</h3>
            <br/>
            <p className="fs_md mb_md">
                개인정보보호법에 따라 에 회원가입 신청하시는 분께 수집하는 개인정보의 항목,
                개인정보의 수집 및 이용목적, 개인정보의 보유 및 이용기간에 관한 사항을 안내 드리오니
                자세히 읽은 후 가입하여 주시기 바랍니다.
            </p>
            <p className="fs_lg tc-p mb_md">회원 가입 요청 시 모든 사항을 동의하는 것으로 간주합니다.</p>
            <br/>
            <p className="fs_md mb_md">주식회사 캠핑톡(이하 “회사”)는 이용자의 개인정보를 소중하게 생각하며, '정보통신망 이용촉진 및 정보보호 등에 관한 법률'과 '개인정보보호법' 등 관련 법령을 준수하고 있습니다.</p>

            <h3 className="fs_lg tc-p  mb_md">01. 이용자 및 법정대리인의 권리와 의무</h3>
            <ul className="mb_lg">
                <li className="fs_md mb_sm">이용자는 언제든지 자신의 개인정보를 조회하고 수정할 수 있습니다. (회원정보변경)</li>
                <li className="fs_md mb_sm">개인정보 제공 동의 철회 및 회원 탈퇴 요청이 가능합니다. (회원탈퇴)</li>
                <li className="fs_md mb_sm">14세 미만 아동의 경우, 법정대리인이 아동의 개인정보를 조회 및 수정할 권리를 가집니다.</li>
            </ul>

            <h3 className="fs_lg tc-p  mb_md">02. 개인정보 보호책임자 및 담당자</h3>

            <table className="table-gray mb_lg">
                <tr>
                    <th className="fs_md txt-a-c">구분</th>
                    <th className="fs_md txt-a-c">이름</th>
                    <th className="fs_md txt-a-c">전화</th>
                    <th className="fs_md txt-a-c">이메일</th>
                </tr>
                <tr>
                    <td className="fs_md txt-a-c">개인정보 보호 책임자</td>
                    <td className="fs_md txt-a-c">김성우</td>
                    <td className="fs_md txt-a-c">010-1234-5678</td>
                    <td className="fs_md txt-a-c">privacy@campLounge.com</td>
                </tr>
                <tr>
                    <td className="fs_md txt-a-c">개인정보 보호 책임자</td>
                    <td className="fs_md txt-a-c">양찬식</td>
                    <td className="fs_md txt-a-c">010-1234-5678</td>
                    <td className="fs_md txt-a-c">privacy@campLounge.com</td>
                </tr>
                <tr>
                    <td className="fs_md txt-a-c">개인정보 보호 담당자</td>
                    <td className="fs_md txt-a-c">손수용</td>
                    <td className="fs_md txt-a-c">010-1234-5678</td>
                    <td className="fs_md txt-a-c">privacy@campLounge.com</td>
                </tr>
                <tr>
                    <td className="fs_md txt-a-c">개인정보 보호 담당자</td>
                    <td className="fs_md txt-a-c">최수민</td>
                    <td className="fs_md txt-a-c">010-1234-5678</td>
                    <td className="fs_md txt-a-c">privacy@campLounge.com</td>
                </tr>
            </table>
            <h3 className="fs_lg tc-p mb_md">03. 수집하는 개인정보</h3>
            <p className="fs_md mb_md">
                이용자는 회원가입을 하지 않아도 캠핑장 정보 검색 등 일부  서비스를
                회원과 동일하게 이용할 수 있습니다. 하지만, 캠핑장 예약, 멤버 간 채팅, 리뷰 작성 등 서비스
                이용을 위해 필요한 최소한의 개인정보를 수집합니다.
            </p>
            <br/>
            <p className="fs_md mb_md">회원가입 시점에 가 이용자로부터 수집하는 개인정보는 아래와 같습니다.
                <br/>
                - 회원 가입 시 필수항목으로 아이디, 비밀번호, 이름, 전화번호를, 선택항목으로 성별을 수집합니다.</p>
            <br/>
            <p className="fs_md mb_md">서비스 이용 과정에서 이용자로부터 수집하는 개인정보는 아래와 같습니다.</p>
            <p className="fs_md mb_md">
                - 회원정보 또는 개별 서비스에서 프로필 정보(프로필 사진)를 설정할 수 있습니다. 회원정보에 프로필 사진을 입력하지 않은 경우에는 기본 이미지가 자동 등록됩니다.
                <br/>
                -  내의 개별 서비스 이용, 이벤트 응모 및 경품 신청 과정에서 해당 서비스의 이용자에 한해 추가 개인정보 수집이 발생할 수 있습니다. 추가로 개인정보를 수집할 경우에는 해당
                개인정보 수집 시점에서 이용자에게 ‘수집하는 개인정보 항목, 개인정보의 수집 및 이용목적, 개인정보의 보관기간’에 대해 안내 드리고 동의를 받습니다.
            </p>
            <br/>
            <p className="fs_md mb_md">
                서비스 이용 과정에서 IP 주소, 쿠키, 서비스 이용 기록, 기기정보, 위치정보가 생성되어 수집될 수 있습니다. 또한 이미지 및 음성을 이용한 검색 서비스 등에서 이미지나 음성이 수집될
                수 있습니다.
                <br/>
                구체적으로 1) 서비스 이용 과정에서 이용자에 관한 정보를 자동화된 방법으로 생성하거나 이용자가 입력한 정보를 저장(수집)하거나, 2) 이용자 기기의 고유한 정보를 원래의 값을 확인하지
                못 하도록 안전하게 변환하여 수집합니다.
            </p>

            <br/>

            <h3 className="fs_lg tc-p mb_md">
                생성정보 수집에 대한 추가 설명
            </h3>
            <p className="fs_md mb_lg">
                - IP(Internet Protocol) 주소란?
                IP 주소는 인터넷 망 사업자가 인터넷에 접속하는 이용자의 PC 등 기기에 부여하는 온라인 주소정보 입니다. IP 주소가 개인정보에 해당하는지 여부에 대해서는 각국마다 매우 다양한 견해가
                있습니다.
                <br/>
                <br/>
                - 서비스 이용기록이란?
                <br/>
                 접속 일시, 이용한 서비스 목록 및 서비스 이용 과정에서 발생하는 정상 또는 비정상 로그 일체,메일 수발신 과정에서 기록되는 이메일주소, 친구 초대하기 또는 선물하기 등에서
                입력하는 휴대전화번호, 스마트스토어 판매자와 구매자간 상담내역(톡톡 및 상품 Q&A 게시글) 등을 의미합니다. 정보주체가 식별되는 일부 서비스 이용기록(행태정보 포함)과 관련한
                처리 목적 등에 대해서는 본 개인정보 처리방침에서 규정하고 있는 수집하는 개인정보, 수집한 개인정보의 이용, 개인정보의 파기 등에서 설명하고 있습니다. 이는 서비스 제공을 위해 수반되는
                것으로 이를 거부하시는 경우 서비스 이용에 제한이 있을 수 있으며, 관련하여서는 고객센터로 문의해주시길 바랍니다. 이 외에 정보주체를 식별하지 않고 행태정보를 처리하는 경우와 관련하여서는
                ' 맞춤형 광고 안내'에서 확인하실 수 있습니다.
                <br/>
                <br/>
                - 기기정보란?
                <br/>
                본 개인정보처리방침에 기재된 기기정보는 생산 및 판매 과정에서 기기에 부여된 정보뿐 아니라, 기기의 구동을 위해 사용되는 S/W를 통해 확인 가능한 정보를 모두 일컫습니다.
                OS(Windows, MAC OS 등) 설치 과정에서 이용자가 PC에 부여하는 컴퓨터의 이름, PC에 장착된 주변기기의 일련번호, 스마트폰의 통신에 필요한 고유한 식별값(IMEI,
                IMSI), AAID 혹은 IDFA, 설정언어 및 설정 표준시, USIM의 통신사 코드 등을 의미합니다. 단, 는 IMEI와 같은 기기의 고유한 식별값을 수집할 필요가 있는
                경우, 이를 수집하기 전에 도 원래의 값을 알아볼 수 없는 방식으로 암호화 하여 식별성(Identifiability)을 제거한 후에 수집합니다.
                <br/>
                <br/>
                - 쿠키(cookie)란?
                <br/>
                쿠키는 이용자가 웹사이트를 접속할 때에 해당 웹사이트에서 이용자의 웹브라우저를 통해 이용자의 PC에 저장하는 매우 작은 크기의 텍스트 파일입니다. 이후 이용자가 다시 웹사이트를 방문할
                경우 웹사이트 서버는 이용자 PC에 저장된 쿠키의 내용을 읽어 이용자가 설정한 서비스 이용 환경을 유지하여 편리한 인터넷 서비스 이용을 가능케 합니다. 또한 방문한 서비스 정보, 서비스
                접속 시간 및 빈도, 서비스 이용 과정에서 생성된 또는 제공(입력)한 정보 등을 분석하여 이용자의 취향과 관심에 특화된 서비스(광고 포함)를 제공할 수 있습니다. 이용자는 쿠키에 대한
                선택권을 가지고 있으며, 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 다만, 쿠키의
                저장을 거부할 경우에는 로그인이 필요한  일부 서비스의 이용에 불편이 있을 수 있습니다.
                <br/>
                <br/>
                웹 브라우저에서 쿠키 허용/차단 방법
                <br/>
                - 크롬(Chrome) : 웹 브라우저 설정 > 개인정보 보호 및 보안 > 인터넷 사용 기록 삭제
                <br/>
                - 엣지(Edge) : 웹 브라우저 설정 > 쿠키 및 사이트 권한 > 쿠키 및 사이트 데이터 관리 및 삭제
                <br/>
                <br/>
                모바일 브라우저에서 쿠키 허용/차단
                <br/>
                - 크롬(Chrome) : 모바일 브라우저 설정 > 개인정보 보호 및 보안 > 인터넷 사용 기록 삭제
                <br/>
                - 사파리(Safari) : 모바일 기기 설정 > 사파리(Safari) > 고급 > 모든 쿠키 차단
                <br/>
                - 삼성 인터넷 : 모바일 브라우저 설정 > 인터넷 사용 기록 > 인터넷 사용 기록 삭제
            </p>

            <h3 className="fs_lg tc-p mb_md">04. 수집한 개인정보의 이용</h3>
            <p className="fs_md mb_md"> 및  관련 제반 서비스(모바일 웹/앱 포함)의 회원관리, 서비스 개발・제공 및 향상, 안전한 인터넷 이용환경 구축 등 아래의 목적으로만 개인정보를 이용합니다.</p>
            <br/>
            <ul className="mb_lg">
                <li className="fs_md mb_sm">- 회원 가입 의사의 확인, 회원탈퇴 의사의 확인 등 회원관리를 위하여 개인정보를 이용합니다.</li>
                <li className="fs_md mb_sm">- 유료 서비스 제공에 따르는 본인인증, 구매 및 요금 결제, 상품 및 서비스의 배송을 위하여 개인정보를 이용합니다.</li>
                <li className="fs_md mb_sm">- 이벤트 정보 및 참여기회 제공, 광고성 정보 제공 등 마케팅 및 프로모션 목적으로 개인정보를 이용합니다.</li>
                <li className="fs_md mb_sm">- 서비스 이용기록과 접속 빈도 분석, 서비스 이용에 대한 통계, 서비스 분석 및 통계에 따른 맞춤 서비스 제공 및 광고 게재 등에 개인정보를 이용합니다.</li>
                <li className="fs_md mb_sm">- 보안, 프라이버시, 안전 측면에서 이용자가 안심하고 이용할 수 있는 서비스 이용환경 구축을 위해 개인정보를 이용합니다.</li>
            </ul>

            <br/>
            <h3 className="fs_lg tc-p mb_md">05. 개인정보의 보관 기간</h3>
            <p className="fs_md mb_lg">회사는 원칙적으로 이용자의 개인정보를 회원 탈퇴 시 탈퇴 날짜를 기준으로 30일간 보관 후 삭제하고 있습니다.</p>

            <br/>
            <h3 className="fs_lg tc-p mb_md">06. 개인정보 수집 및 이용 동의를 거부할 권리</h3>
            <p className="fs_md mb_lg">
                이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. 회원가입 시 수집하는 최소한의 개인정보, 즉, 필수 항목에 대한 수집 및 이용 동의를 거부하실 경우, 회원가입이 어려울
                수 있습니다.
            </p>

            <h3 className="fs_lg tc-p  mb_md">07. 개인정보 관련 문의</h3>
            <p className="fs_md mb_md">개인정보 침해 신고 및 상담이 필요한 경우 아래 기관에 문의하시기 바랍니다.</p>
            <ul>
                <li className="fs_md mb_sm">개인정보침해 신고센터: 국번없이 118 / <a className="fs_md" href="https://privacy.kisa.or.kr" target="_blank">privacy.kisa.or.kr</a>
                </li>
                <li className="fs_md mb_sm">개인정보 분쟁조정위원회: 1833-6972 / <a className="fs_md" href="https://www.kopico.go.kr" target="_blank">www.kopico.go.kr</a>
                </li>
                <li className="fs_md mb_sm">대검찰청 사이버수사과: 국번없이 1301 / <a className="fs_md" href="https://www.spo.go.kr" target="_blank">www.spo.go.kr</a></li>
                <li className="fs_md mb_sm">경찰청 사이버안전국: 국번없이 182 / <a className="fs_md" href="https://cyberbureau.police.go.kr"
                                              target="_blank">cyberbureau.police.go.kr</a></li>
            </ul>
        </div>

    );
};

export default PrivacyPolicy;